import React, { useState, useEffect, useContext, useCallback } from "react";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  getEmployeeList,
  getEmployeeDashboardCount,
} from "./Service/employeeService";
import { FilterMatchMode, FilterService } from "primereact/api";
import Preloader from "../../../Shared/Sidebar/Preloader";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions";

function EmployeeList() {
  let userPermissions = getRawPermissionsArray();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [employee, setEmployee] = useState([]);
  const [loader, setLoading] = useState(true);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [employeeCount, setEmployeeCount] = useState([]);
  const { showLoading, hideLoading } = useContext(LoaderContext);
  const [showInfo, setShowInfo] = useState(false);
  const defaultImage = "/images/placeholder_profile.png";
  const [employeeCreate,setEmployeeCreate] = useState(false);

  useEffect(() => {
    fetchEmployeeData();
    getEmployeeCount();
    permissionAccouncementList();
  }, []);

  const permissionAccouncementList = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Employee.Delete") {
        setShowInfo(true);
      }else if (UserPermission.PermissionName == "Employee.Create") {
        setEmployeeCreate(true);
      }
    });
  };

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: 0,
      LoggedInEmployeeId: 0,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 100000,
      EmployeeId: 0,
             IsSuggestedOnly: 0,
    };

    try {
      showLoading();
      let employeesList = await getEmployeeList(params);
      employeesList?.Data?.forEach((el) => {
        el.BiometricNumber =
          el?.BiometricNumber == 1 ? "Verified " : "Unverified";
      });
      setEmployee(employeesList.Data);
      setTotalRecords(employeesList.Data[0]?.totalEmpCount);
      hideLoading();
    } catch (error) {
      hideLoading();
    }
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Link
          to={`/Profile/${rowData.GUID}`}
          className="btn btn-primary shadow btn-xs sharp"
          style={{ marginRight: "3px" }}
          title="View"
        >
          <i className="fa fa-eye"></i>
        </Link>
        {showInfo && (
          <a className="btn btn-danger shadow btn-xs sharp me-1" title="Delete">
            <i className="fa fa-trash"></i>
          </a>
        )}</div>
    );
  };

  const onSelectionChange = (event) => {
    const value = event.value;
    setSelectedEmployees(value);
    setSelectAll(value.length === totalRecords);
  };

  const onSelectAllChange = (event) => {
    const selectAll = event.checked;

    if (selectAll) {
      setSelectAll(true);
      setSelectedEmployees(employee);
    } else {
      setSelectAll(false);
      setSelectedEmployees([]);
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const tableStyle = {
    border: "1px solid #ccc",
    borderRadius: "5px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
  };

  async function getEmployeeCount() {
    try {
      showLoading();
      let getEmployeeDashboardCountData = await getEmployeeDashboardCount();
      // let getEmployeeDashboardCountData = await data.json();
      setEmployeeCount(getEmployeeDashboardCountData.Data);
      hideLoading();
    } catch (error) {
      hideLoading();
    }
  }

   const styleFullName = (rowData) => {
      return (
        <Link to={`/Profile/${rowData.GUID}`}>
          <div className="d-flex align-items-center">
            <img
              src={rowData?.ProfileImage || defaultImage}
              onError={handleImageError}
              className="rounded-lg me-2"
              width="24"
              alt=""
            />{" "}
            <span className="w-space-no">{rowData.OverseerName ? rowData.OverseerName : 'N/A'}</span>
          </div>
        </Link>
      );
    };

    const styleReportingName = (rowData) => {
      return (      
          <div className="d-flex align-items-center">
            <img
              src={rowData?.OverseerImage || defaultImage}
              onError={handleImageError}
              className="rounded-lg me-2"
              width="24"
              alt=""
            />{" "}
            <span className="w-space-no">{rowData.OverseerName ? rowData.OverseerName : 'N/A'}</span>
          </div>
      );
    };

     const handleImageError = useCallback((event) => {
        event.target.src = defaultImage;
      }, []);

  useEffect(() => {}, [totalRecords]);

  return (
    <div className="container-fluid pb-4">
      <div className="row g-3">
        <div className="form-head d-flex flex-wrap align-items-center">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">Employee List </h2>
          </div>
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="input-group search-area2 d-xl-inline-flex">
              <button className="input-group-text">
                <i className="fa fa-search text-primary"></i>
              </button>
              <input
                type="text"
                value={globalFilterValue}
                onChange={onGlobalFilterChange}
                className="form-control"
                placeholder="Search here..."
              />
            </div>
            {employeeCreate && <Link to={"/Employee/Add"} className="add-btncss022">
              <i aria-hidden="true" className="fa fa-plus me-2"></i>New Member
            </Link>}
          </div>
        </div>
        <div className="tile-grid tile-grid-v1">
          <div className="employee-card">
            <div className="">
              <div className="columns is-multiline project-grid mt-0">
                <div className="column is-one-fifth">
                  <a className="project-grid-item">
                    <LazyImage
                      src="images/emp-list/1-img.svg"
                      className="countyr"
                    />
                    <p>{employeeCount.totalEmployeeCount}</p>
                    <h3>Total Employees</h3>
                  </a>
                </div>
                <div className="column is-one-fifth">
                  <a className="project-grid-item">
                    <LazyImage
                      src="images/emp-list/2-img.svg"
                      className="countyr"
                    />
                    <p>{employeeCount.teams}</p>
                    <h3>Teams</h3>
                  </a>
                </div>
                <div className="column is-one-fifth">
                  <a className="project-grid-item">
                    <LazyImage
                      src="images/emp-list/3-img.svg"
                      className="countyr"
                    />
                    <p>{employeeCount.activeEmployee}</p>
                    <h3>Active Employee</h3>
                  </a>
                </div>
                <div className="column is-one-fifth">
                  <a className="project-grid-item">
                    <LazyImage
                      src="images/emp-list/4-img.svg"
                      className="countyr"
                    />
                    <p>{employeeCount.newEmployee}</p>
                    <h3>New Employee</h3>
                  </a>
                </div>
                <div className="column is-one-fifth">
                  <a className="project-grid-item">
                    <LazyImage
                      src="images/emp-list/5-img.svg"
                      className="countyr"
                    />
                    <p>{employeeCount.teamLeader}</p>
                    <h3>Team Leaders</h3>
                  </a>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "20px",
                }}
              >
                <DataTable
                  value={employee}
                  paginator
                  rows={10}
                  totalRecords={totalRecords} // Add this line
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  filters={filters}
                  globalFilterFields={["FullName", "UserName", "Contacts"]}
                  dataKey="Id"
                  tableStyle={{ minWidth: "50rem", fontSize: "12px" }}
                  selection={selectedEmployees}
                  onSelectionChange={onSelectionChange}
                  selectAll={selectAll}
                  onSelectAllChange={onSelectAllChange}
                  emptyMessage="No employees found."
                >
                  <Column selectionMode="multiple" />
                  <Column field="FullName"  body={styleFullName} header="Name" sortable></Column>
                  <Column
                    field="UserName"
                    header="Email Id"
                    body={(rowData) =>
                      rowData.UserName ? rowData.UserName : "N/A"
                    }
                    sortable
                  ></Column>
                  <Column
                    field="Contacts"
                    header="Phone"
                    body={(rowData) =>
                      rowData.Contacts ? rowData.Contacts : "N/A"
                    }
                    sortable
                  ></Column>
                  <Column
                    field="AssociatedSince"
                    header="Associated Since"
                    body={(rowData) =>
                      rowData.AssociatedSince ? moment(rowData.AssociatedSince).format(
                        "MMM DD YYYY"
                      ) : "N/A"
                      
                    }
                    sortable
                  ></Column>
                  <Column
                    field="OverseerName"
                    header="Reporting Manager"
                    body={styleReportingName}
                    sortable
                  ></Column>
                  <Column
                    field="EmpId"
                    header="Member Id"
                    body={(rowData) => (rowData.EmpId ? rowData.EmpId : "N/A")}
                    sortable
                  ></Column>
                  <Column
                    field="ParentName"
                    header="Parent Name"
                    body={(rowData) =>
                      rowData.ParentName ? rowData.ParentName : "N/A"
                    }
                    sortable
                  ></Column>
                  {showInfo && (
                    <Column field="BiometricNumber" header="Biometric" sortable>
                      {" "}
                    </Column>
                  )}
                   <Column
                    header="Action"
                    body={actionBodyTemplate}
                    style={{ width: "70px" }}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>{loader ? <Preloader /> : ""}</div>
    </div>
  );
}
export default EmployeeList;
